// extracted by mini-css-extract-plugin
export var iconContainer = "_cr-0";
export var metricCardsContainer = "_cr-1";